<template>
	<div class="skyCheckBoxCardPrd">
		<!-- <div class="title">产品推广分类</div> -->
		<el-row class="filter" :gutter="20">
			<el-col :span="5">
				<sky-select
					v-model="selValue"
					:options="options"
					@change="change"
					:clearable="false"
					size="medium"
				></sky-select
			></el-col>
			<el-col :span="5"
				><sky-select
					v-model="two_selValue"
					:options="two_options"
					@change="two_change"
					size="medium"
					v-if="two_select"
					:props="props"
				></sky-select
			></el-col>
		</el-row>
		<div v-loading="loading">
			<div class="choice_box" v-if="classifyData.length">
				<!-- <classifyChoice
					:value="value"
					v-bind="item"
					v-for="(item, index) in classifyData"
					:key="index"
					@check="checkChange"
				></classifyChoice> -->
				<el-checkbox-group class="skyCheckbox" v-model="checkboxs" @change="handleChange" v-bind="$attrs">
					<el-checkbox
						v-for="(item, index) in classifyData"
						:label="item[attr.id]"
						:key="index"
						border
					>
						<span> {{ item[attr.fileName] }} </span>
						<span class="preview" @click="openUrl(item[attr.url],$event)"> 查看页面 </span>
					</el-checkbox>
				</el-checkbox-group>
			</div>
			<div class="choice_box info" v-else>
				<!-- <img src="../../../assets/empty_images/zanwushuju.png" /> -->
				<div>暂无数据</div>
			</div>
		</div>
	</div>
</template>
<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
// import classifyChoice from '@/components/adsOnlineAuto/com/classifyChoice';
import { isHave } from '@/utils/index.js';
import { mapGetters } from 'vuex';
export default {
	props: {
		value: {
			type: Array,
			default: () => []
		},
		length: {
			type: Number,
			default: 1
		},
		domain: {
			type: String,
			default: ''
		},
		attr: {
			type: Object,
			default() {
				return {
					id: 'id',
					url: 'path',
					fileName: 'name'
				};
			}
		},
		filterOptions: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			selValue: '0',
			options: [
				{
					value: '0',
					label: '全部分类',
				},
				{
					value: '1',
					label: '一级分类',
				},
				{
					value: '2',
					label: '二级分类',
				},
				{
					value: '3',
					label: '三级分类',
				},
			],
			two_select: false,
			two_options: [],
			oneClassify: [],
			twoClassify: [],
			threeClassify: [],
			props: {
				label: 'name',
				value: 'id',
			},
			two_selValue: '',
			classifyData: [],
			allData: [],
			choose: [],
			checkboxs: ['1503358070745505792'],
			otherData: [],
			loading: false,
		};
	},
	components: { skySelect },
	computed: {
		...mapGetters(['activeWebsite']),
	},
	watch: {
		value: {
			handler(val) {
				if (val && val.length) {
					this.checkboxs = val.map(item => item[this.attr.id]);
				}else {
					this.checkboxs = [];
				}
				// this.choose = val;
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		handleChange(val) {
			// 单选时，清除多余的选项
			if(this.length == 1 && this.checkboxs.length > 1) {
				this.checkboxs.shift();
			}
			let data = this.classifyData.filter(item => isHave(item[this.attr.id], val));
			this.$emit('input', data);
			this.$emit('change', data);
		},
		// 跳转链接打开新窗口
    openUrl(http, e) {
			e.preventDefault();
			e.stopPropagation();
			let url = 'https://' + this.domain + http;
      window.open(url, '_blank');
    },
		change(val) {
			if (val == '0') {
				this.classifyData = this.allData;
				this.two_select = false;
			}
			if (val == '1') {
				this.classifyData = this.oneClassify;
				this.two_select = false;
			}
			if (val == '2') {
				this.two_options = this.oneClassify;
				this.classifyData = this.twoClassify;
				this.two_select = true;
			}
			if (val == '3') {
				this.two_options = this.twoClassify;
				this.classifyData = this.threeClassify;
				this.two_select = true;
			}
		},
		two_change(val) {
			if (val) {
				this.classifyData = this.allData.filter(e => {
					return e.pid === val;
				});
			} else {
				if (this.selValue == '2') {
					this.classifyData = this.twoClassify;
				}
				if (this.selValue == '3') {
					this.classifyData = this.threeClassify;
				}
			}
		},
		checkChange(obj) {
			let flag = this.choose.some(item => {
				return obj.productTypeId == item.productTypeId;
			});
			if (flag) {
				this.choose = this.choose.filter(function (ele) {
					return ele.productTypeId != obj.productTypeId;
				});
			} else {
				this.choose.push(obj);
			}
			this.$emit('input', this.choose);
		},
		async getData() {
			try {
				this.loading = true;
				let res = await adsNewOnline.classifyList({ siteid: sessionStorage.getItem('projectId') });
				this.loading = false;
				this.allData = res.data;
				this.classifyData = this.allData;
				this.oneClassify = this.allData.filter(e => {
					return e.pid === '0';
				});
				this.otherData = this.allData.filter(e => {
					return e.pid != '0';
				});
				this.oneClassify.forEach(query => {
					this.otherData.forEach(item => {
						if (query.id === item.pid) {
							this.twoClassify.push(item);
						}
					});
				});
				this.twoClassify.forEach(query => {
					this.otherData.forEach(item => {
						if (query.id === item.pid) {
							this.threeClassify.push(item);
						}
					});
				});
			} catch (error) {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.getData();
	},
};
</script>

<style lang="scss" scoped>
.skyCheckBoxCardPrd {
	.title {
		font-size: 16px;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.85);
	}
	.filter {
		margin: 30px 0px;
	}
	.choice_box {
		// display: grid;
		// grid-template-columns: repeat(5, 18.5%);
		// gap: 20px;
		.el-checkbox-group {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
		}
		.skyCheckbox {
			margin: 5px 0;
			max-height: 400px;
			overflow-y: scroll;
		}
		.el-checkbox {
			height: auto;
			width: 200px;
			white-space: break-spaces;
			margin-left: 0px !important;
			margin-right: 5.5% !important;
			margin-bottom: 20px !important;
			display: flex;
			flex-direction: column;
			padding: 9px 20px 20px 10px;
			width: 29%;
		}
		.el-checkbox-group.skyCheckbox .el-checkbox:nth-child(3n) {
			margin-right: 0px !important;
		}
		.el-checkbox:last-of-type {
			margin-right: 30px;
		}
		.preview {
			position: absolute;
			right: 0;
			bottom: 0;
			color: #409eff;
			cursor: pointer;
			z-index: 2;
		}
	}
	.info {
		padding: 30px;
		font-size: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			width: 280px;
		}

		div {
			font-size: 15px;
			font-weight: 400;
			color: #666666;
			line-height: 21px;
		}
	}
}
</style>
